export class AssignmentGroupsRequest {
    constructor(public scopes: string[], public assignmentTypes: number[]) {}
  }
